import hasNegativePercentage from './hasNegativePercentage';

export default hasNegativePercentage;
